(function () {
  'use strict';

  angular.module('app').component('serviceItemDetail', serviceItemDetail());

  function serviceItemDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        fast: '<',
        activeTab: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
      },
      controller: ServiceItemDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/service-items/service-item-detail/service-item-detail.component.html',
    };
  }

  ServiceItemDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ServiceItemService',
    'ProductCategoryService',
    'MeasurementUnitService',
    'SessionService',
    'TaxService',
    'ProductService',
    '$cacheFactory',

    // Angular downgraded service
    'companyService',
  ];

  function ServiceItemDetailComponent(
    config,
    UtilService,
    ServiceItemService,
    ProductCategoryService,
    MeasurementUnitService,
    SessionService,
    TaxService,
    ProductService,
    $cacheFactory,

    // Angular downgraded service
    companyService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.checkedProductTypes = [];
    vm.costTypes = config.COST_TYPES;

    // Methods
    vm.selectProductCategory = selectProductCategory;
    vm.openProductCategoriesModal = openProductCategoriesModal;

    vm.checkProductType = checkProductType;

    vm.editServiceItem = editServiceItem;
    vm.cancelEdit = cancelEdit;
    vm.saveServiceItem = saveServiceItem;
    vm.cancel = cancel;

    vm.selectAssociatedProviders = selectAssociatedProviders;
    vm.onAssociatedProviderSaved = onAssociatedProviderSaved;
    vm.onAssociatedProviderDeleted = onAssociatedProviderDeleted;
    vm.onSelectedTab = onSelectedTab;

    vm.selectAssociatedTaxes = selectAssociatedTaxes;
    vm.onAssociatedTaxesSaved = onAssociatedTaxesSaved;
    vm.onAssociatedTaxesCanceled = onAssociatedTaxesCanceled;

    vm.selectCostsAndPrices = selectCostsAndPrices;
    vm.onCostsAndPricesSaved = onCostsAndPricesSaved;

    // Navigation
    vm.serviceItems = [];
    vm.loadingServiceItems = false;
    vm.serviceItemSelected = null;
    vm.loadingOtherServiceItem = false;
    vm.getServiceItems = getServiceItems;
    vm.selectServiceItem = selectServiceItem;
    vm.goToOtherServiceItem = goToOtherServiceItem;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        vm.active = vm.activeTab ? parseInt(vm.activeTab) : 0;

        setItemOptions(vm.item, vm.mode);
        getServerData(vm.item);
        getServiceItems();
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          company_id: SessionService.getSelectedAccountCompany().id,
          sellable: false,
        };

        getProductCategories('');
      }

      vm.originalItem = angular.copy(vm.item); // store server data

      // Initializers
      getCompany();

      getProductTypes();
    };

    vm.openSearchCabys = function (item) {
      const succesCallBack = (itemObj) => {
        vm.item.cabys_code = itemObj.codigo;
        vm.item.cabys_description = itemObj.descripcion;
        vm.item.cabys_tax = itemObj.impuesto;
      };

      ProductService.openSearchCabys(item, succesCallBack);
    };

    vm.searchCabys = function () {
      if (!vm.item.cabys_code || vm.item.cabys_code.length < 13) return;

      let searchBy = 'codigo=' + vm.item.cabys_code.toLowerCase();

      vm.clearCabys();

      vm.invalidCabys = false;

      vm.searchingCabys = true;
      ProductService.searchCabys(searchBy).then(function (data) {
        // console.log(data);
        if (data[0] && data[0].codigo) {
          vm.item.cabys_code = data[0].codigo;
          vm.item.cabys_description = data[0].descripcion;
          vm.item.cabys_tax = data[0].impuesto;

          vm.invalidCabys = false;
        } else {
          vm.invalidCabys = true;
        }

        vm.searchingCabys = false;
      });
    };

    vm.clearCabys = function () {
      vm.item.cabys_description = '';
      vm.item.cabys_tax = '';
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editServiceItem();
      }

      vm.productCategorySelected = item.product_category;

      setCheckedProductTypes(vm.item.product_types);

      vm.customTaxConfiguration = item.custom_tax_configuration;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data
      vm.flashMessage = vm.UtilService._displayFlashMessage();
    }

    function getServerData(item) {
      // To reload code number consecutive
      getProductCategories('');
    }

    function editServiceItem() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getProductTypes() {
      var productTypes = angular.copy(vm.UtilService.getProductTypes());
      vm.productTypes = vm.UtilService.removeItemFromArray(productTypes, 'type', 'service_item');

      if (!vm.createMode) {
        vm.productTypes.forEach(function (productType) {
          vm.item.associated_in.forEach(function (associatedIn) {
            if (productType.type === associatedIn.product_type) {
              productType.associated_in = associatedIn.associated_in;
            }
          });
        });
      }
    }

    function setCheckedProductTypes(productTypes) {
      vm.isCheckedProductTypes = productTypes.length > 0 ? true : false;

      productTypes.forEach(function (productType) {
        vm.checkedProductTypes[productType] = true;
      });
    }

    function checkProductType() {
      vm.isCheckedProductTypes = Object.keys(vm.checkedProductTypes).some(function (key) {
        return vm.checkedProductTypes[key];
      });
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: vm.defaultLanguage,
        })
        .subscribe((response) => {
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes;
          }

          vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
            response.measurement_units,
            'service_item'
          );

          if (!vm.createMode) {
            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              vm.item.measurement_unit_id
            );
          }
        });
    }

    // Create/Update
    function saveServiceItem(isFormValid) {
      vm.formErrors = false;

      if (
        !isFormValid ||
        vm.productCategories.length === 0
        // || (vm.atvCrEnabled && !vm.item.cabys_description)
      ) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var checkedProductTypes = [];

      for (var key in vm.checkedProductTypes) {
        if (vm.checkedProductTypes[key]) {
          // add only true values to array
          checkedProductTypes.push(key);
        }
      }

      vm.item.product_types = checkedProductTypes;

      vm.sendingForm = true;
      ServiceItemService.saveServiceItem(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: response });
          } else {
            vm.item = response;
            setItemOptions(response);

            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              response.measurement_unit_id
            );

            vm.flashMessage = vm.UtilService._clearFlashMessage();
            vm.UtilService.scrollToTop();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;

          vm.UtilService.scrollToTop();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem({ item: vm.item });
    }

    // ----- PRODUCT CATEGORIES ----- //

    function getProductCategories(option) {
      var params = {
        get: 'active',
        by_product_type: 'service_item',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories(params).then(function (data) {
        vm.productCategories = data.items;
        vm.loadingProductCategories = false;

        if (option === 'update') {
          var productCategory = vm.UtilService.findItemInArray(
            vm.productCategories,
            'id',
            vm.productCategorySelected.id
          );
          vm.productCategorySelected = null;
          selectProductCategory(productCategory);
        }
      });
    }

    function selectProductCategory(productCategory) {
      if (vm.productCategorySelected && vm.productCategorySelected.id === productCategory.id) {
        // Same product category is selected
        return;
      }

      vm.productCategorySelected = productCategory;

      vm.item.code_number = '';

      // Edit mode
      if (vm.editMode) {
        // Same product category as the item
        if (vm.originalItem.product_category_id === productCategory.id) {
          vm.item.code = vm.originalItem.code;
          vm.item.code_number = vm.originalItem.code_number;
        } else if (productCategory.coding_type === 'automatic') {
          vm.item.code =
            productCategory.coding_prefix + productCategory.nextProductCodeNumberToAssign;
          vm.item.code_number = productCategory.nextProductCodeNumberToAssign;
        }
      }
    }

    function openProductCategoriesModal() {
      var successCallback = function () {
        getProductCategories('update');
      };

      ProductCategoryService.openProductCategoriesModal(successCallback);
    }

    // ----- ASSOCIATED PROVIDERS ----- //

    function selectAssociatedProviders() {
      vm.showAssociatedProviders = true;
    }

    function onAssociatedProviderSaved(product, items) {
      vm.item.default_provider_id = product.default_provider_id;

      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onAssociatedProviderDeleted(items) {
      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onSelectedTab(tab) {
      vm.active = tab;
    }

    // ----- ASSOCIATED TAXES -----

    function selectAssociatedTaxes(reload) {
      if (vm.taxes && !reload) {
        return;
      }

      let productCategoryAssociatedTaxes = {
        purchases: [],
        sales: [],
      };

      if (vm.item.product_category.associated_taxes) {
        vm.item.product_category.associated_taxes.map((associated_tax) => {
          if (associated_tax.scope_type === 'purchases') {
            productCategoryAssociatedTaxes.purchases.push(associated_tax);
          } else {
            productCategoryAssociatedTaxes.sales.push(associated_tax);
          }
        });
      }

      vm.taxes = TaxService.setAssociatedTaxes(
        productCategoryAssociatedTaxes,
        vm.item.associated_taxes,
        vm.taxTypes
      );
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function onAssociatedTaxesSaved(product) {
      if (!vm.customTaxConfiguration) {
        delete product.exonerations;
      }

      vm.item = product;
      vm.originalItem = angular.copy(vm.item);
      // vm.taxesOriginal = angular.copy(vm.taxes);

      selectAssociatedTaxes(true);
    }

    function onAssociatedTaxesCanceled() {
      vm.customTaxConfiguration = vm.originalItem.custom_tax_configuration;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    // ----- COSTS AND PRICES -----

    function selectCostsAndPrices() {
      vm.showCostsAndPrices = true;
    }

    function onCostsAndPricesSaved(associated_providers) {
      vm.item.associated_providers = associated_providers;
      vm.originalItem.associated_providers = associated_providers;
    }

    function getServiceItems() {
      if (ServiceItemService.hasServiceItemsCache()) {
        const cachedData = ServiceItemService.getServiceItemsCache();
        vm.serviceItems = cachedData;
        setServiceItemNavigation();
        return;
      }

      const params = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
        per_page: 10000,
        skip_check_role: true,
      };

      vm.loadingServiceItems = true;
      ServiceItemService.getServiceItems(params).then(
        function (data) {
          const serviceItemsData = data.items || [];

          vm.serviceItems = [];
          serviceItemsData.forEach((item, index) => {
            item.prev = serviceItemsData[index - 1];
            item.next = serviceItemsData[index + 1];
            vm.serviceItems.push(item);
          });

          ServiceItemService.setServiceItemsCache(vm.serviceItems);
          setServiceItemNavigation();
          vm.loadingServiceItems = false;
        },
        function () {
          vm.loadingServiceItems = false;
        }
      );
    }

    function setServiceItemNavigation() {
      vm.serviceItemSelected = { ...vm.item };

      const serviceItemFound = vm.serviceItems.find((si) => si.id === vm.item.id);

      if (serviceItemFound) {
        vm.serviceItemSelected.prev = serviceItemFound.prev;
        vm.serviceItemSelected.next = serviceItemFound.next;
      }
    }

    function selectServiceItem(id) {
      goToOtherServiceItem(id);
    }

    function goToOtherServiceItem(id) {
      if (!id || vm.loadingOtherServiceItem) {
        return;
      }

      vm.loadingOtherServiceItem = true;

      ServiceItemService.getServiceItem(id, {
        skip_check_role: true,
        lang: vm.defaultLanguage,
      }).then(
        function (serviceItem) {
          vm.item = serviceItem;
          setItemOptions(serviceItem);
          getServerData(serviceItem);
          setServiceItemNavigation();
          vm.loadingOtherServiceItem = false;
        },
        function () {
          vm.loadingOtherServiceItem = false;
        }
      );
    }
  }
})();
